import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import InsertTestOrder from "./InsertTestOrder";

const TestOrderForm: React.FC = () => {
  return (
    <Flex direction="column" bgColor="white" p={4}>
      <Box p={4} bg="white" borderRadius="md" boxShadow="sm">
        <InsertTestOrder />
      </Box>
    </Flex>
  );
};

export default TestOrderForm;
